module.exports = {"id":"200984","name":"Rafael Martins","rating":"74","photo":"./data/images/photos/0/200984.png","club":{"name":"Vit. Guimarães","logo":"./data/images/clubs/Vit.Guimaraes.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RafaelMartins0.json
// module id = 3510
// module chunks = 0